/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { useIsAccessAllow } from "../../../../../app/modules/users/redux";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    let isActive = checkIsActive(location, url);
    if (url === "/dashboard" && checkIsActive(location, "/analytics-dashboard")) {
      isActive = true;
    }
    return isActive
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };
  
  const isUserListAllow = useIsAccessAllow("user.list");
  const isContactListAllow = useIsAccessAllow("contact_us.list");
  const isColdLeadsAllow = useIsAccessAllow("coldleads.list");
  const isNewDataCallAllow = useIsAccessAllow("new_data_call.list");
  const isIncomingCallsAllow = useIsAccessAllow("incomingCalls.list");
  const isGetAQuoteListAllow = useIsAccessAllow("get_a_quote.list");
  const isGenerativeAIListAllow = useIsAccessAllow("get_genAI_quote.list");
  const isCareersListAllow = useIsAccessAllow("careers.list");
  const isBlogListAllow = useIsAccessAllow("blog.list");
  const isTagListAllow = useIsAccessAllow("tag.list");
  const isCategoryListAllow = useIsAccessAllow("category.list");
  const isAuthorListAllow = useIsAccessAllow("author.list");
  const isEmailManagementListAllow = useIsAccessAllow("email_management.list");
  const isMailSubscribersListAllow = useIsAccessAllow("mail_subscribers.list");
  const isDubaiBlogListAllow = useIsAccessAllow("dubai_blog.list");
  const isDubaiTagListAllow = useIsAccessAllow("dubai_tag.list");
  const isDubaiCategoryListAllow = useIsAccessAllow("dubai_category.list");
  const isHireAIBlogListAllow = useIsAccessAllow("hire_ai_blog.list");
  const isHireAITagListAllow = useIsAccessAllow("hire_ai_tag.list");
  const isHireAICategoryListAllow = useIsAccessAllow("hire_ai_category.list");
  const isDubaiAuthorListAllow = useIsAccessAllow("dubai_author.list");
  const isHireAIAuthorListAllow = useIsAccessAllow("hire_ai_author.list");
  const isHfdiBlogListAllow = useIsAccessAllow("hfdi_blog.list");
  const isHfdiTagListAllow = useIsAccessAllow("hfdi_tag.list");
  const isHfdiCategoryListAllow = useIsAccessAllow("hfdi_category.list");
  const isHfdiAuthorListAllow = useIsAccessAllow("hfdi_author.list");
  const isHfdiCareersListAllow = useIsAccessAllow("hfdi_careers.list");
  const isHfdiCareersInquiryListAllow = useIsAccessAllow("inquirycareers.list");
  const isWebcluesCareersListAllow = useIsAccessAllow("webclues_careers.list");
  const isWebCareersCityListAllow = useIsAccessAllow("webcareerscity.list");
  const isIcodBlogListAllow = useIsAccessAllow("icod_blog.list");
  const isIcodTagListAllow = useIsAccessAllow("icod_tag.list");
  const isIcodCategoryListAllow = useIsAccessAllow("icod_category.list");
  const isIcodAuthorListAllow = useIsAccessAllow("icod_author.list");
  const isFdcBlogListAllow = useIsAccessAllow("fdc_blog.list");
  const isFdcTagListAllow = useIsAccessAllow("fdc_tag.list");
  const isFdcCategoryListAllow = useIsAccessAllow("fdc_category.list");
  const isFdcAuthorListAllow = useIsAccessAllow("fdc_author.list");
  const isHbdBlogListAllow = useIsAccessAllow("hbd_blog.list");
  const isHbdTagListAllow = useIsAccessAllow("hbd_tag.list");
  const isHbdCategoryListAllow = useIsAccessAllow("hbd_category.list");
  const isHbdAuthorListAllow = useIsAccessAllow("hbd_author.list");
  const isBdcBlogListAllow = useIsAccessAllow("bdc_blog.list");
  const isBdcTagListAllow = useIsAccessAllow("bdc_tag.list");
  const isBdcCategoryListAllow = useIsAccessAllow("bdc_category.list");
  const isBdcAuthorListAllow = useIsAccessAllow("bdc_author.list");
  const isHfdBlogListAllow = useIsAccessAllow("hfd_blog.list");
  const isHfdTagListAllow = useIsAccessAllow("hfd_tag.list");
  const isHfdCategoryListAllow = useIsAccessAllow("hfd_category.list");
  const isHfdAuthorListAllow = useIsAccessAllow("hfd_author.list");
  const isHdpBlogListAllow = useIsAccessAllow("hdp_blog.list");
  const isHdpTagListAllow = useIsAccessAllow("hdp_tag.list");
  const isHdpCategoryListAllow = useIsAccessAllow("hdp_category.list");
  const isHdpAuthorListAllow = useIsAccessAllow("hdp_author.list");
  const isSettingsAllow = useIsAccessAllow("settings.*");
  const isAccountstAllow = useIsAccessAllow("whatsapp_account.list");
  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li className={`menu-item ${getMenuItemActive("/dashboard", false)}`}>
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>

        {isUserListAllow && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/user-management",
              true
            ) ||
              getMenuItemActive("/user", true) ||
              getMenuItemActive("/role", true)}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/user">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Contact1.svg"
                  )}
                />
              </span>
              <span className="menu-text">User Management</span>
              <i className="menu-arrow" />
            </NavLink>

            <div className="menu-submenu ">
              <ul className="menu-subnav">
                {isUserListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive("/user", false)}`}
                  >
                    <NavLink className="menu-link" to="/user">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Group.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Users</span>
                    </NavLink>
                  </li>
                )}

                {/* <li className={`menu-item ${getMenuItemActive("/role", false)}`}>
                <NavLink className="menu-link" to="/role">
                  <span className="svg-icon menu-icon">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Communication/Contact1.svg"
                      )}
                    />
                  </span>
                  <span className="menu-text">Role</span>
                </NavLink>
              </li> */}
              </ul>
            </div>
          </li>
        )}
        {/* 

        {/* Contact Us */}
        {isContactListAllow && (
          <li
            className={`menu-item ${getMenuItemActive("/contact-us", false)}`}
          >
            <NavLink className="menu-link" to="/contact-us">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Contact1.svg"
                  )}
                />
              </span>
              <span className="menu-text">Contact Us</span>
            </NavLink>
          </li>
        )}

        {isColdLeadsAllow && (
          <li
            className={`menu-item ${getMenuItemActive("/old-leads", false)}`}
          >
            <NavLink className="menu-link" to="/old-leads">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Contact1.svg"
                  )}
                />
              </span>
              <span className="menu-text">Old Leads Calling</span>
            </NavLink>
          </li>
        )}

      {isNewDataCallAllow && (
        <li
          className={`menu-item ${getMenuItemActive("/new-data-call", false)}`}
        >
          <NavLink className="menu-link" to="/new-data-call">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/Contact1.svg"
                )}
              />
            </span>
            <span className="menu-text">New Data Call</span>
          </NavLink>
        </li>
      )}
              
        {isIncomingCallsAllow && (
          <li
            className={`menu-item ${getMenuItemActive("/incoming-calls", false)}`}
          >
            <NavLink className="menu-link" to="/incoming-calls">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Contact1.svg"
                  )}
                />
              </span>
              <span className="menu-text">Incoming Calls</span>
            </NavLink>
          </li>
        )}


        {/* Quote Us */}
        {isGetAQuoteListAllow && (
          <li className={`menu-item ${getMenuItemActive("/quote", false)}`}>
            <NavLink className="menu-link" to="/quote">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Contact1.svg"
                  )}
                />
              </span>
              <span className="menu-text">Get A Quote</span>
            </NavLink>
          </li>
        )}

        {/* Settings */}
        {isSettingsAllow && (
        <li className={`menu-item ${getMenuItemActive("/settings", false)}`}>
          <NavLink className="menu-link" to="/settings">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/General/Settings-2.svg"
                )}
              />
            </span>
            <span className="menu-text">Settings</span>
          </NavLink>
        </li>
        )}
        {/* Generative AI */}
        {/* {isGenerativeAIListAllow && (
          <li
            className={`menu-item ${getMenuItemActive("/generativeAI", false)}`}
          >
            <NavLink className="menu-link" to="/generativeAI">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Contact1.svg"
                  )}
                />
              </span>
              <span className="menu-text">Generative AI</span>
            </NavLink>
          </li>
        )}*/}

        {/* Careers */}
        {isCareersListAllow && (
          <li className={`menu-item ${getMenuItemActive("/careers", false)}`}>
            <NavLink className="menu-link" to="/careers">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Contact1.svg"
                  )}
                />
              </span>
              <span className="menu-text">Careers</span>
            </NavLink>
          </li>
        )}

        {(isBlogListAllow ||
          isTagListAllow ||
          isCategoryListAllow ||
          isAuthorListAllow ||
          isWebcluesCareersListAllow ||
          isWebCareersCityListAllow) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/blog",
              true
            ) ||
              getMenuItemActive("/tag", true) ||
              getMenuItemActive("/category", true) ||
              getMenuItemActive("/author", true) ||
              getMenuItemActive("/webclues_careers", true) ||
              getMenuItemActive("/web_careers_city", true)}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            {
              <NavLink className="menu-link menu-toggle" to="/blog">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Contact1.svg"
                    )}
                  />
                </span>
                <span className="menu-text">WebClues Blog</span>
                <i className="menu-arrow" />
              </NavLink>
            }

            <div className="menu-submenu ">
              <ul className="menu-subnav">
                {isBlogListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive("/blog", false)}`}
                  >
                    <NavLink className="menu-link" to="/blog">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Blog</span>
                    </NavLink>
                  </li>
                )}

                {isTagListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive("/tag", false)}`}
                  >
                    <NavLink className="menu-link" to="/tag">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Tag</span>
                    </NavLink>
                  </li>
                )}

                {isCategoryListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/category",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/category">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Category</span>
                    </NavLink>
                  </li>
                )}
                {isAuthorListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/author",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/author">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Author</span>
                    </NavLink>
                  </li>
                )}

                {isWebcluesCareersListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/webclues_careers",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/webclues_careers">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Careers</span>
                    </NavLink>
                  </li>
                )}

                {isWebCareersCityListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/web_careers_city",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/web_careers_city">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Add Careers City</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )}

        {/* ------------------------- Ster Dubai Blog -------------------------- */}
        {(isDubaiBlogListAllow ||
          isDubaiTagListAllow ||
          isDubaiCategoryListAllow ||
          isDubaiAuthorListAllow) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/dubai_blog",
              true
            ) ||
              getMenuItemActive("/dubai_tag", true) ||
              getMenuItemActive("/dubai_author", true) ||
              getMenuItemActive("/dubai_category", true)}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            {
              <NavLink className="menu-link menu-toggle" to="/dubai_blog">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Contact1.svg"
                    )}
                  />
                </span>
                <span className="menu-text">Dubai Blog</span>
                <i className="menu-arrow" />
              </NavLink>
            }

            <div className="menu-submenu ">
              <ul className="menu-subnav">
                {isDubaiBlogListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/dubai_blog",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/dubai_blog">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Blog</span>
                    </NavLink>
                  </li>
                )}

                {isDubaiTagListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/dubai_tag",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/dubai_tag">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Tag</span>
                    </NavLink>
                  </li>
                )}

                {isDubaiCategoryListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/dubai_category",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/dubai_category">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Category</span>
                    </NavLink>
                  </li>
                )}
                {isDubaiAuthorListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/dubai_author",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/dubai_author">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Author</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )}

        {/* ------------------------- End Dubai Blog -------------------------- */}

        {/* ------------------------- Start Hire AI Blog -------------------------- */}
        {(isHireAIBlogListAllow ||
          isHireAITagListAllow ||
          isHireAICategoryListAllow ||
          isHireAIAuthorListAllow) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/hire_ai_blog",
              true
            ) ||
              getMenuItemActive("/hire_ai_tag", true) ||
              getMenuItemActive("/hire_ai_author", true) ||
              getMenuItemActive("/hire_ai_category", true)}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            {
              <NavLink className="menu-link menu-toggle" to="/hire_ai_blog">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Contact1.svg"
                    )}
                  />
                </span>
                <span className="menu-text">Hire AI Blog</span>
                <i className="menu-arrow" />
              </NavLink>
            }

            <div className="menu-submenu ">
              <ul className="menu-subnav">
                {isHireAIBlogListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hire_ai_blog",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hire_ai_blog">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Blog</span>
                    </NavLink>
                  </li>
                )}

                {isHireAITagListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hire_ai_tag",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hire_ai_tag">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Tag</span>
                    </NavLink>
                  </li>
                )}

                {isHireAICategoryListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hire_ai_category",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hire_ai_category">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Category</span>
                    </NavLink>
                  </li>
                )}
                {isHireAIAuthorListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hire_ai_author",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hire_ai_author">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Author</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )}

        {/* ------------------------- End Hire AI Blog -------------------------- */}

        {/* ------------------------- Start HFDI Blog -------------------------- */}
        {(isHfdiBlogListAllow ||
          isHfdiTagListAllow ||
          isHfdiCategoryListAllow ||
          isHfdiAuthorListAllow ||
          isHfdiCareersListAllow) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/hfdi_blog",
              true
            ) ||
              getMenuItemActive("/hfdi_tag", true) ||
              getMenuItemActive("/hfdi_author", true) ||
              getMenuItemActive("/hfdi_category", true)}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            {
              <NavLink className="menu-link menu-toggle" to="/hfdi_blog">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Contact1.svg"
                    )}
                  />
                </span>
                <span className="menu-text">HFDI Blog</span>
                <i className="menu-arrow" />
              </NavLink>
            }

            <div className="menu-submenu ">
              <ul className="menu-subnav">
                {isHfdiBlogListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hfdi_blog",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hfdi_blog">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Blog</span>
                    </NavLink>
                  </li>
                )}

                {isHfdiTagListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hfdi_tag",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hfdi_tag">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Tag</span>
                    </NavLink>
                  </li>
                )}

                {isHfdiCategoryListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hfdi_category",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hfdi_category">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Category</span>
                    </NavLink>
                  </li>
                )}
                {isHfdiAuthorListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hfdi_author",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hfdi_author">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Author</span>
                    </NavLink>
                  </li>
                )}

                {isHfdiCareersListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hfdi_careers",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hfdi_careers">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Careers</span>
                    </NavLink>
                  </li>
                )}

                {isHfdiCareersInquiryListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/inquirycareers",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/inquirycareers">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Careers Inquiry</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )}

        {/* ------------------------- End HFDI Blog -------------------------- */}

        {/* ------------------------- Start ICOD Blog -------------------------- */}
        {(isIcodBlogListAllow ||
          isIcodTagListAllow ||
          isIcodCategoryListAllow ||
          isIcodAuthorListAllow) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/icod_blog",
              true
            ) ||
              getMenuItemActive("/icod_tag", true) ||
              getMenuItemActive("/icod_author", true) ||
              getMenuItemActive("/icod_category", true)}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            {
              <NavLink className="menu-link menu-toggle" to="/icod_blog">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Contact1.svg"
                    )}
                  />
                </span>
                <span className="menu-text">ICOD Blog</span>
                <i className="menu-arrow" />
              </NavLink>
            }

            <div className="menu-submenu ">
              <ul className="menu-subnav">
                {isIcodBlogListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/icod_blog",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/icod_blog">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Blog</span>
                    </NavLink>
                  </li>
                )}

                {isIcodTagListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/icod_tag",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/icod_tag">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Tag</span>
                    </NavLink>
                  </li>
                )}

                {isIcodCategoryListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/icod_category",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/icod_category">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Category</span>
                    </NavLink>
                  </li>
                )}
                {isIcodAuthorListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/icod_author",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/icod_author">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Author</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )}

        {/* ------------------------- End ICOD Blog -------------------------- */}

        {/* ------------------------- Start FDC Blog -------------------------- */}
        {(isFdcBlogListAllow ||
          isFdcTagListAllow ||
          isFdcCategoryListAllow ||
          isFdcAuthorListAllow) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/fdc_blog",
              true
            ) ||
              getMenuItemActive("/fdc_tag", true) ||
              getMenuItemActive("/fdc_author", true) ||
              getMenuItemActive("/fdc_category", true)}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            {
              <NavLink className="menu-link menu-toggle" to="/fdc_blog">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Contact1.svg"
                    )}
                  />
                </span>
                <span className="menu-text">FDC Blog</span>
                <i className="menu-arrow" />
              </NavLink>
            }

            <div className="menu-submenu ">
              <ul className="menu-subnav">
                {isFdcBlogListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/fdc_blog",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/fdc_blog">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Blog</span>
                    </NavLink>
                  </li>
                )}

                {isFdcTagListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/fdc_tag",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/fdc_tag">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Tag</span>
                    </NavLink>
                  </li>
                )}

                {isFdcCategoryListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/fdc_category",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/fdc_category">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Category</span>
                    </NavLink>
                  </li>
                )}
                {isFdcAuthorListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/fdc_author",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/fdc_author">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Author</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )}

        {/* ------------------------- End FDC Blog -------------------------- */}

        {/* ------------------------- Start HBD Blog -------------------------- */}
        {(isHbdBlogListAllow ||
          isHbdTagListAllow ||
          isHbdCategoryListAllow ||
          isHbdAuthorListAllow) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/hbd_blog",
              true
            ) ||
              getMenuItemActive("/hbd_tag", true) ||
              getMenuItemActive("/hbd_author", true) ||
              getMenuItemActive("/hbd_category", true)}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            {
              <NavLink className="menu-link menu-toggle" to="/hbd_blog">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Contact1.svg"
                    )}
                  />
                </span>
                <span className="menu-text">HBD Blog</span>
                <i className="menu-arrow" />
              </NavLink>
            }

            <div className="menu-submenu ">
              <ul className="menu-subnav">
                {isHbdBlogListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hbd_blog",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hbd_blog">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Blog</span>
                    </NavLink>
                  </li>
                )}

                {isHbdTagListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hbd_tag",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hbd_tag">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Tag</span>
                    </NavLink>
                  </li>
                )}

                {isHbdCategoryListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hbd_category",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hbd_category">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Category</span>
                    </NavLink>
                  </li>
                )}
                {isHbdAuthorListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hbd_author",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hbd_author">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Author</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )}

        {/* ------------------------- End HBD Blog -------------------------- */}

        {/* ------------------------- Start BDC Blog -------------------------- */}
        {(isBdcBlogListAllow ||
          isBdcTagListAllow ||
          isBdcCategoryListAllow ||
          isBdcAuthorListAllow) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/bdc_blog",
              true
            ) ||
              getMenuItemActive("/bdc_tag", true) ||
              getMenuItemActive("/bdc_author", true) ||
              getMenuItemActive("/bdc_category", true)}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            {
              <NavLink className="menu-link menu-toggle" to="/bdc_blog">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Contact1.svg"
                    )}
                  />
                </span>
                <span className="menu-text">BDC Blog</span>
                <i className="menu-arrow" />
              </NavLink>
            }

            <div className="menu-submenu ">
              <ul className="menu-subnav">
                {isBdcBlogListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/bdc_blog",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/bdc_blog">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Blog</span>
                    </NavLink>
                  </li>
                )}

                {isBdcTagListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/bdc_tag",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/bdc_tag">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Tag</span>
                    </NavLink>
                  </li>
                )}

                {isBdcCategoryListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/bdc_category",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/bdc_category">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Category</span>
                    </NavLink>
                  </li>
                )}
                {isBdcAuthorListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/bdc_author",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/bdc_author">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Author</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )}

        {/* ------------------------- End BDC Blog -------------------------- */}

        {/* ------------------------- Start HFD Blog -------------------------- */}
        {(isHfdBlogListAllow ||
          isHfdTagListAllow ||
          isHfdCategoryListAllow ||
          isHfdAuthorListAllow) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/hfd_blog",
              true
            ) ||
              getMenuItemActive("/hfd_tag", true) ||
              getMenuItemActive("/hfd_author", true) ||
              getMenuItemActive("/hfd_category", true)}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            {
              <NavLink className="menu-link menu-toggle" to="/hfd_blog">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Contact1.svg"
                    )}
                  />
                </span>
                <span className="menu-text">HFD Blog</span>
                <i className="menu-arrow" />
              </NavLink>
            }

            <div className="menu-submenu ">
              <ul className="menu-subnav">
                {isHfdBlogListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hfd_blog",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hfd_blog">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Blog</span>
                    </NavLink>
                  </li>
                )}

                {isHfdTagListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hfd_tag",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hfd_tag">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Tag</span>
                    </NavLink>
                  </li>
                )}

                {isHfdCategoryListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hfd_category",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hfd_category">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Category</span>
                    </NavLink>
                  </li>
                )}
                {isHfdAuthorListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hfd_author",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hfd_author">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Author</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )}

        {/* ------------------------- End HFD Blog -------------------------- */}

        {/* ------------------------- Start HDP Blog -------------------------- */}
        {(isHdpBlogListAllow ||
          isHdpTagListAllow ||
          isHdpCategoryListAllow ||
          isHdpAuthorListAllow) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/hdp_blog",
              true
            ) ||
              getMenuItemActive("/hdp_tag", true) ||
              getMenuItemActive("/hdp_author", true) ||
              getMenuItemActive("/hdp_category", true)}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            {
              <NavLink className="menu-link menu-toggle" to="/hdp_blog">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Contact1.svg"
                    )}
                  />
                </span>
                <span className="menu-text">HDP Blog</span>
                <i className="menu-arrow" />
              </NavLink>
            }

            <div className="menu-submenu ">
              <ul className="menu-subnav">
                {isHdpBlogListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hdp_blog",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hdp_blog">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Blog</span>
                    </NavLink>
                  </li>
                )}

                {isHdpTagListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hdp_tag",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hdp_tag">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Tag</span>
                    </NavLink>
                  </li>
                )}

                {isHdpCategoryListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hdp_category",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hdp_category">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Category</span>
                    </NavLink>
                  </li>
                )}
                {isHdpAuthorListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/hdp_author",
                      false
                    )}`}
                  >
                    <NavLink className="menu-link" to="/hdp_author">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Contact1.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Author</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )}
        {/* ------------------------- End HDP Blog -------------------------- */}

        {isEmailManagementListAllow && (
          <li
            className={`menu-item ${getMenuItemActive(
              "/email-management",
              false
            )}`}
          >
            <NavLink className="menu-link" to="/email-management">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Contact1.svg"
                  )}
                />
              </span>
              <span className="menu-text">Email Management</span>
            </NavLink>
          </li>
        )}

        {isMailSubscribersListAllow && (
          <li
            className={`menu-item ${getMenuItemActive(
              "/mail-subscribers",
              false
            )}`}
          >
            <NavLink className="menu-link" to="/mail-subscribers">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Contact1.svg"
                  )}
                />
              </span>
              <span className="menu-text">Mail Subscribers</span>
            </NavLink>
          </li>
        )}
        {isAccountstAllow && (
        <li
          className={`menu-item ${getMenuItemActive(
            "/whatsapp/accounts",
            false
          )}`}
        >
          <NavLink className="menu-link" to="/whatsapp/accounts">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/Contact1.svg"
                )}
              />
            </span>
            <span className="menu-text">Whatsapp Accounts</span>
          </NavLink>
        </li>
        )}
        {/* Page Speed Score */}
        {isContactListAllow && (
          <li
            className={`menu-item ${getMenuItemActive(
              "/page-speed-score",
              false
            )}`}
          >
            <NavLink className="menu-link" to="/page-speed">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Contact1.svg"
                  )}
                />
              </span>
              <span className="menu-text">Page Speed Score</span>
            </NavLink>
          </li>
        )}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
